import React, { PureComponent } from 'react';
import './Swatches.css';
import { singleValueAttributeUpdater } from './utils/handler';
import message from '../../../helper/message';

class Swatch extends PureComponent {
  render() {
    const {
      value,
      text,
      disabled,
      thumbnailurl,
      selected,
      onChange,
      orientation,
    } = this.props;

    const divClassName = `swatchContainer ${disabled ? 'disabled' : ''} ${
      orientation === 'vertical' ? 'vertical' : ''
    }`;
    const imageClassName = `swatchImage ${selected ? 'selected' : ''}`;
    return (
      <div className={divClassName} onClick={onChange}>
        <img className={imageClassName} src={thumbnailurl} alt={value} />
        <div className="swatchText">{text}</div>
      </div>
    );
  }
}

export default class Swatches extends PureComponent {
  onChange = ({ value, disabled }) => ev => {
    if (this.props.disabled || disabled) return;
    singleValueAttributeUpdater(this.props, value);
  };

  render() {
    const {
      configuration,
      attributeName,
      appApi,
      orientation,
      onChange,
      disabled,
    } = this.props;
    const { label, autoHide } = appApi.config.getAttribute(attributeName);
    const swatchOptions = appApi.config.getAttributeAvailableValues(
      attributeName,
      configuration
    );

    if (autoHide && !swatchOptions.length) return <div />;
    // for dev, remove in product mode
    onChange &&
      message.warn(
        `The onchange function for ${attributeName} has been override, please take care of the import disable inside override function!`
      );
    ///////////////////
    return (
      <div className="attrContainer">
        {label && <div className="swatchesLabel label">{label}</div>}
        <div
          className={`swatchesContainer 
          ${orientation === 'vertical' ? 'vertical' : ''}`}
        >
          {swatchOptions.map(option => (
            <Swatch
              key={option.value}
              orientation={orientation}
              {...option}
              selected={configuration[attributeName].value === option.value}
              onChange={(onChange && onChange(option)) || this.onChange(option)}
              disabled={disabled || option.disabled}
            />
          ))}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Attributes/standardAttributes/Swatches.js